import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { EncounterProvider } from './contexts/EncounterContext';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import ScheduleBoard from './pages/ScheduleBoard';
import CheckInPage from './pages/CheckInPage';
import ProviderQueue from './pages/ProviderQueue';
import LiveVisit from './pages/LiveVisit';
import CommandCenter from './pages/CommandCenter';
import PatientChart from './pages/PatientChart';
import ComparisonDashboard from './pages/ComparisonDashboard';
import AuditLog from './pages/AuditLog';
import SettingsPage from './pages/SettingsPage';
import VisitMetrics from './pages/VisitMetrics';
import PreVisitDashboard from './pages/PreVisitDashboard';
import DocumentInbox from './pages/DocumentInbox';
import UserManagement from './pages/UserManagement';
import PatientSearch from './pages/PatientSearch';
import FinalizedNote from './pages/FinalizedNote';
import RevenueWorkspace from './pages/RevenueWorkspace';
import RevenueCaseDetail from './pages/RevenueCaseDetail';
import RevenueBatchWorkspace from './pages/RevenueBatchWorkspace';
import RevenuePolicyAdmin from './pages/RevenuePolicyAdmin';
import RevenueAnalyticsPage from './pages/RevenueAnalyticsPage';
import RevenueAnalyticsDrilldown from './pages/RevenueAnalyticsDrilldown';
import QualityAdmin from './pages/QualityAdmin';
import QualityDashboard from './pages/QualityDashboard';
import QualityOutreach from './pages/QualityOutreach';
import QualityRegistry from './pages/QualityRegistry';
import QilTestDashboard from './pages/QilTestDashboard';
import NurseIntake from './pages/NurseIntake';
import WorkClerkDashboard from './pages/WorkClerkDashboard';
import CodingQueue from './pages/CodingQueue';
import CodingWorkspace from './pages/CodingWorkspace';
import RcmAnalyticsDashboard from './pages/RcmAnalyticsDashboard';
import RcmWorkspace from './pages/RcmWorkspace';
import FinalizationPage from './pages/FinalizationPage';
import OrdersWorkspace from './pages/OrdersWorkspace';
import ClinicDocManager from './pages/ClinicDocManager';
import MyDay from './pages/MyDay';
import NurseMessages from './pages/NurseMessages';
import BillingTestReport from './pages/BillingTestReport';
import NursingVisitNote from './pages/NursingVisitNote';
import NavRail from './components/layout/NavRail';
import DictationWidget from './components/DictationWidget';
import FloatingAIBubble from './components/FloatingAIBubble';
import './App.css';function ProtectedLayout() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  return (
    <EncounterProvider>
      <div className="flex h-screen overflow-hidden bg-background relative p-0">
        <NavRail />
        <main className="flex-1 overflow-auto relative">
          <Routes>
            <Route path="/" element={<MyDay />} />
            <Route path="/my-day" element={<MyDay />} />
            <Route path="/orders" element={<OrdersWorkspace />} />
            <Route path="/doc-manager" element={<ClinicDocManager />} />
            <Route path="/schedule" element={<ScheduleBoard />} />
            <Route path="/checkin/:appointmentId" element={<CheckInPage />} />
            <Route path="/queue" element={<ProviderQueue />} />
            <Route path="/visit/:encounterId" element={<LiveVisit />} />
            <Route path="/finalize/:encounterId" element={<FinalizationPage />} />
            <Route path="/note/:encounterId" element={<FinalizedNote />} />
            <Route path="/command-center/:encounterId" element={<CommandCenter />} />
            <Route path="/patients" element={<PatientSearch />} />
            <Route path="/chart/:patientId" element={<PatientChart />} />
            <Route path="/comparisons" element={<ComparisonDashboard />} />
            <Route path="/audit" element={<AuditLog />} />
            <Route path="/metrics" element={<VisitMetrics />} />
            <Route path="/pre-visit" element={<PreVisitDashboard />} />
            <Route path="/documents" element={<DocumentInbox />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/revenue" element={<RevenueWorkspace />} />
            <Route path="/revenue/case/:caseId" element={<RevenueCaseDetail />} />
            <Route path="/revenue/batches" element={<RevenueBatchWorkspace />} />
            <Route path="/revenue/policies" element={<RevenuePolicyAdmin />} />
            <Route path="/revenue/analytics" element={<RevenueAnalyticsPage />} />
            <Route path="/revenue/analytics/failures" element={<RevenueAnalyticsDrilldown />} />
            <Route path="/revenue/analytics/governance" element={<RevenueAnalyticsDrilldown />} />
            <Route path="/revenue/analytics/financial" element={<RevenueAnalyticsDrilldown />} />
            <Route path="/quality-admin" element={<QualityAdmin />} />
            <Route path="/quality-dashboard" element={<QualityDashboard />} />
            <Route path="/quality-outreach" element={<QualityOutreach />} />
            <Route path="/quality-registry" element={<QualityRegistry />} />
            <Route path="/qil-test-dashboard" element={<QilTestDashboard />} />
            <Route path="/nurse-intake/:appointmentId" element={<NurseIntake />} />
            <Route path="/nurse-messages" element={<NurseMessages />} />
            <Route path="/work-clerk" element={<WorkClerkDashboard />} />
            <Route path="/coding-queue" element={<CodingQueue />} />
            <Route path="/coding-workspace" element={<CodingWorkspace />} />
            <Route path="/rcm-analytics" element={<RcmAnalyticsDashboard />} />
            <Route path="/rcm-workspace" element={<RcmWorkspace />} />
            <Route path="/billing/test-report" element={<BillingTestReport />} />
            <Route path="/patients/:patientId/nursing-visit/new" element={<NursingVisitNote />} />
          </Routes>
        </main>
        <DictationWidget />
      </div>
      <Toaster position="bottom-right" />
    </EncounterProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<ProtectedLayout />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
